const modelNames = [
  'typeAColors',
  // 'tags',
  // 'skus',
  // 'stocks',
  // 'pricebooks',
  // 'prices',
  'accounts',
  'paymentMethods',
  // 'customers',
  'staffers',
  'suppliers',
  'brands',
  'lensTypes',
  'stores',
  'products',
  'entries',
  'serieses',
  'itemBarcodes',
]

const models = { }
modelNames.forEach(name => {
  models[name] = require(`./${name}.js`)
})

module.exports = models



// WEBPACK FOOTER //
// ./src/models/index.js